import React from "react";
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';
import cx from "classnames";
import styles from "./style.module.scss";

const SelectInput = (props) => {
  const { className, inputProps, onChange, onBlur, value, selectStyles, inputErrors = false,
    isDisabled, creatable = false, id, options = [], placeholder = "Seleccione uno ", defaultValue } = props;
  const SelectTag = creatable ? CreatableSelect : Select;

  // useEffect(() => {
  //   if(defaultValue){
  //     const options = getOptions();
  //     const value = options.find(o => o.value === defaultValue);
  //     triggerOnChange(value);
  //   }
  // }, [defaultValue]);

  const getSelectProps = () => {
    if (creatable) {
      return {
        onCreateOption: (e) => createCustomOption(e),
        formatCreateLabel: (options) => {
          return options;
        },
        isClearable: true
      }
    }
  }

  const createOption = (label) => ({
    label,
    value: label,
  });

  const createCustomOption = (option) => {
    const newOption = createOption(option);
    triggerOnChange(newOption);
  }

  const triggerOnChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  }

  const triggerOnBlur = (e) => {
    if (onBlur) {
      e.target.name = inputProps.name;
      onBlur(e);
    }
  }

  const getOptions = () => {
    if (value) {
      const selectOptions = [
        ...options,
        value
      ]
      return getUniqueListBy(selectOptions, "value");
    }
    return options;
  }

  const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()];
  }

  const getSelectStyle = () => {
    return {
      menu: (base) => ({
        ...base,
        zIndex: 1000
      }),
      ...selectStyles,
    }
  }

  return (
    <div className={styles.selectDropdown}>
      <SelectTag
        {...inputProps}
        {...(getSelectProps())}
        placeholder={placeholder}
        options={getOptions()}
        value={value}
        isDisabled={isDisabled}
        className={cx(
          {
            "is-invalid form-control": inputErrors,
            [styles.errorPadding]: inputErrors,
            className: className
          }
        )}
        styles={getSelectStyle()}
        onChange={(e) => triggerOnChange(e)}
        onBlur={(e) => triggerOnBlur(e)}
        id={id}
      />

      {inputErrors}
    </div>
  );
}

export default SelectInput;